VLW.controllers.AuthentifierBouteille = class extends VLW.controllers.Home {
    constructor(a, b) {
        super(a, b);
        this.pixi.align="rb";
        this.pixi.displacementType=VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_MENTIONS;
        this.constructor.setStyleMenuHover("color_gris");
        this._initComponent();
    }
	
	introContent(delay=0){
		let tl            = new TimelineMax({delay});
		tl.to		(this.mainElementJS		,.75	,{opacity:1});
		return true;
	}
	_clearComponent(){
        if(this.formRequete){
			this.formRequete.events.onSubmit.remove(this.onSubmit);
			this.formRequete.instanceClean();
			this.formRequete=null;
        }
		if(this.formSignaler){
			this.formSignaler.events.onSubmit.remove(this.onSubmit);
			this.formSignaler.instanceClean();
			this.formSignaler=null;
		}
		this.qs("[controller-click='onClickSignaler']") &&  this.qs("[controller-click='onClickSignaler']").removeEventListener('click', this.onClickSignaler);
		this.qs("._retour")                             &&  this.qs("._retour").removeEventListener('click', this.onClickRetour);
	
	}
	
    _initComponent(){
        this._clearComponent();
        if(this.qs("#authentification")) {
            this.formRequete = new VLW.form(this.qs("#authentification"));
			this.formRequete.events.onSubmit.add(this.onSubmit);
        }
		this.qs("[controller-click='onClickSignaler']") &&  this.qs("[controller-click='onClickSignaler']").addEventListener('click', this.onClickSignaler);
		this.qs("._retour")                             &&  this.qs("._retour").addEventListener('click', this.onClickRetour);
  		if(this.qs("form#signaler")){
            this.formSignaler = new VLW.form(this.qs("form#signaler"));
			this.formSignaler.events.onSubmit.add(this.onSubmit);
        }
    }

    loadPIXIResources(){
        let _loader = new PIXI.loaders.Loader();
		_loader.add("image", this.getPIXIResourcesBackground());
        _loader.load((loader, resources)=>{this.pixi.resources = resources;loader.destroy()});
    }

    /***
     * Soumission des formulaire
     * @param formData
     */
    onSubmit(formData){
    	TweenMax.set(".page",{scrollTo:{y:0}});
        let _action = formData.form.getAttribute("action");
        let ajax   = new XMLHttpRequest();
        ajax.open('POST', _action, true);
        ajax.setRequestHeader('X-Requested-With'	, 'XMLHttpRequest');
        ajax.setRequestHeader("Content-type"		, "application/x-www-form-urlencoded; charset=UTF-8");
        ajax.onreadystatechange = this._ajaxResponse;
        ajax.send(Object.toQueryString(formData.data));
        site.trackEvent("AuthentificationBouteille","request");
		TweenMax.killTweensOf(this.qs("._contentPlaceHolder"));
        TweenMax.to(this.qs("._contentPlaceHolder"),.35,{opacity: 0});
    }

    /***
     * Callback soumission de formulaire
     * @param _e
     * @private
     */

    _ajaxResponse(_e){
        if(_e.currentTarget.readyState === 4 && _e.currentTarget.status === 200){
            let _body            = JSON.parse(_e.currentTarget.responseText);
            let _loadedDom       = document.createElement('DIV');
            _loadedDom.innerHTML = _body.html;
		    this._switch(_loadedDom.querySelector('section.page section._content'));
			
        }
    }

    /**
     * Switch de contenu
     * @param _content
     * @private
     */
    _switch(elt){
    	this.clear_vlwScroll();
		this.qs("._contentPlaceHolder").innerHTML = "";
		this.qs("._contentPlaceHolder").append(elt);
		this._initComponent();
		this.init_vlwScroll();
		TweenMax.to(this.qs("._contentPlaceHolder"),.35,{opacity: 0,onComplete:()=>{
				TweenMax.to(this.qs("._contentPlaceHolder"),.5,{opacity:1})
		}});
    }

    onClickSignaler(e){
        e.preventDefault();
        e.stopPropagation();
		
		TweenMax.to(this.qs("._contentPlaceHolder"),.35,{opacity: 0,onComplete:()=>{
				this.sendSignalerRequest();
		}});
	
		return false;
    }
    sendSignalerRequest(){
	
		let ajax   = new XMLHttpRequest();
		ajax.open('POST', site.currentPathname, true);
		ajax.setRequestHeader('X-Requested-With'	, 'XMLHttpRequest');
		ajax.setRequestHeader("Content-type"		, "application/x-www-form-urlencoded; charset=UTF-8");
		ajax.onreadystatechange = this._ajaxResponse;
		ajax.send(Object.toQueryString({action:"signaler_contenu"}));
	
	}

    onClickRetour(e){
		TweenMax.killTweensOf(this.qs("._contentPlaceHolder"));
		TweenMax.to(this.qs("._contentPlaceHolder"),.35,{opacity: 0});
        e.preventDefault();
        e.stopPropagation();
        //let _u = e.currentTarget.getAttribute("href");
        site.goTo(site.currentPathname);
        return false;
    }
    
    reload(arg){
        this._initComponent();
		TweenMax.to(this.qs("._contentPlaceHolder"),.35,{opacity: 0,onComplete:this._switch,onCompleteParams:[arg.querySelector("._content")]});
    }
};